import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IUserInfoState } from ".";
import { now } from "../../utils/time";

export interface IMakeProfitResponse {
    balance: number;
}

export const makeProfit = createAsyncThunk<IMakeProfitResponse>(
    'userInfo/makeProfit',
    async () => await api.users.makeProfit()
);

const makeProfitHandler = (builder: ActionReducerMapBuilder<IUserInfoState>) => {
    builder
        .addCase(makeProfit.fulfilled, (state: IUserInfoState, action: PayloadAction<IMakeProfitResponse>) => {
            if (!action.payload)
                return;

            state.balance = action.payload.balance;
            state.lastProfitMaking = now();
        })
};

export default makeProfitHandler;